import { all, takeEvery } from 'redux-saga/effects';
import actions from './actions';
import CollectionSagas from '../Collection/sagas';

class Thematics extends CollectionSagas {

    constructor() {
        super(actions,'thematics', [], 'title');
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.LOAD_FROM_FIRESTORE, new Thematics().loadFromFirestore),
        takeEvery(actions.SAVE_INTO_FIRESTORE, new Thematics().storeIntoFirestore),
    ]);
}
